import {
	fetchAllDeliveryCountries,
	fetchAllGlobalOwners,
	fetchAllIndustries, fetchAllMainClientPersonas,
	fetchAllServiceLines,
	fetchAllTechPractices, fetchCountries, fetchQualificationAttributes
} from "@/common/services/common-graphql-service";
import {searchFtes, searchRevenues} from "@/drc/services/drc-graphql-service";
import {
	fetchAllFilterConfidentialities, getAllCompanies,
	getBusinessContactManager, getCertificates,
	getCompanies, getDeliveryContactManager, getTools
} from "@/drc/services/drc-request-service";
import axios from "axios";
import {EventBusCase} from "@/common/configurations/event-bus";
import {ATTRIBUTE_STATUS, ATTRIBUTE_TYPE} from "@/common/utils/constants";
import {getRecognitionsList} from "@/gop/services/recognition.service";
import {getTrends, getUserLatest, getUserLatestSearches} from "@/common/services/common-request-service";
const URL = process.env.VUE_APP_BACKEND_API_URL;

const state = {
}

const getters = {
	getCommonField: (state) => (fieldName) => {
		return state[fieldName];
	},
	//this.$store.getters.getAllCommonData
	// returns {example: [1,2,3]}
	getAllCommonData(state) {
		return state;
	},
	getIsLoaded(state) {
		return !!(state.isLoadedPrivate && state.isLoadedPublic);
	}
};

const actions = {
	setPublicData({commit}) {
		commit("setPublicData");
	},
	setPrivateData({commit}) {
		commit("setPrivateData");
	},
};

const mutations = {
	setPublicData(state) {
		state.isLoadedPublic = false;
		const promises = [
			fetchAllIndustries()
				.then((response) => {
					state.industries = response
						.sort((a, b) => {
							const nameA = a.translations.find(t => t.language.name === 'EN')?.name || '';
							const nameB = b.translations.find(t => t.language.name === 'EN')?.name || '';
							return nameA.localeCompare(nameB);
						})
						//.sort((a, b) => a.orderNumber - b.orderNumber)
						.map(industry => ({
							...industry,
							subIndustries: industry.subIndustries
								? industry.subIndustries.sort((x, y) => {
									const nameX = x.translations.find(t => t.language.name === 'EN')?.name || '';
									const nameY = y.translations.find(t => t.language.name === 'EN')?.name || '';
									return nameX.localeCompare(nameY);
								})
								: []
						}));
				})
				.catch((error) => console.error(error)),
			fetchAllServiceLines()
				.then((response) => {
					state.serviceLines = response
						.sort((a, b) => {
							const nameA = a.translations.find(t => t.language.name === 'EN')?.name || '';
							const nameB = b.translations.find(t => t.language.name === 'EN')?.name || '';
							return nameA.localeCompare(nameB);
						})
						.map(serviceLine => ({
							...serviceLine,
							subServiceLines: serviceLine.subServiceLines
								? serviceLine.subServiceLines.sort((x, y) => {
									const nameX = x.translations.find(t => t.language.name === 'EN')?.name || '';
									const nameY = y.translations.find(t => t.language.name === 'EN')?.name || '';
									return nameX.localeCompare(nameY);
								})
								: []
						}));
				})
				.catch((error) => console.error(error)),
			fetchAllTechPractices()
				.then((response) => {
					state.techPractices = response
						.sort((a, b) => {
							const nameA = a.translations.find(t => t.language.name === 'EN')?.name || '';
							const nameB = b.translations.find(t => t.language.name === 'EN')?.name || '';
							return nameA.localeCompare(nameB);
						})
						.map(techPractice => ({
							...techPractice,
							subTechPractices: techPractice.subTechPractices
								? techPractice.subTechPractices.sort((x, y) => {
									const nameX = x.translations.find(t => t.language.name === 'EN')?.name || '';
									const nameY = y.translations.find(t => t.language.name === 'EN')?.name || '';
									return nameX.localeCompare(nameY);
								})
								: []
						}));
				})
				.catch((error) => console.error(error)),
			fetchCountries(true).then((response) => state.clientLocations = response)
				.catch((error) => console.error(error)),
			fetchAllDeliveryCountries().then((response) => state.deliveryCountries = response)
				.catch((error) => console.error(error)),
			searchFtes({})
				.then((response) => state.ftes = response)
				.catch((error) => console.error(error)),
			fetchAllFilterConfidentialities()
				.then((response) => state.confidentialities = response.data)
				.catch((error) => console.error(error)),
			searchRevenues({})
				.then((response) => state.revenues = response)
				.catch((error) => console.error(error))
		]
		Promise.all(promises).then(() => {
			state.isLoadedPublic = true;
			if(!!(state.isLoadedPrivate && state.isLoadedPublic)){
				EventBusCase.$emit("isLoaded", true);
			}
		});
	},
	setPrivateData(state) {
		state.isLoadedPrivate = false;
		const promises = [
			fetchQualificationAttributes(ATTRIBUTE_TYPE.tool, [ATTRIBUTE_STATUS.APPROVED, ATTRIBUTE_STATUS.FOR_APPROVAL, ATTRIBUTE_STATUS.INACTIVE], null)
				.then((response) => state.managementTools = response)
				.catch((error) => console.error(error)),
			fetchQualificationAttributes(ATTRIBUTE_TYPE.certification, [ATTRIBUTE_STATUS.APPROVED, ATTRIBUTE_STATUS.FOR_APPROVAL, ATTRIBUTE_STATUS.INACTIVE], null)
				.then((response) => state.managementCertificates = response)
				.catch((error) => console.error(error)),
			getTools({approvalStatuses: ['APPROVED'], type: 'TOOL'})
				.then((response) => state.tools = response.data)
				.catch((error) => console.error(error)),
			getCertificates({approvalStatuses: ['APPROVED'], type: 'CERTIFICATION'})
				.then((response) => state.certificates = response.data)
				.catch((error) => console.error(error)),
			getCompanies({projectConfidentialities: ['EXTERNAL', 'INTERNAL']})
				.then((response) => state.companies = response.data)
				.catch((error) => console.error(error)),
			getAllCompanies()
				.then((response) => state.allCompanies = response.data)
				.catch((error) => console.error(error)),
			getBusinessContactManager({})
				.then((response) => state.businessContactManagers = response.data)
				.catch((error) => console.error(error)),
			getDeliveryContactManager({})
				.then((response) => state.deliveryContactManagers = response.data)
				.catch((error) => console.error(error)),
			axios.get(`${URL}/users/search-filters/reference-owner`)
				.then((response) => state.referenceOwners = response.data)
				.catch((error) => console.error(error)),
			fetchAllMainClientPersonas()
				.then((response) => state.mainClientPersonas = response)
				.catch((error) => console.error(error)),
			fetchAllGlobalOwners()
				.then((response) => state.globalOwners = response)
				.catch((error) => console.error(error)),
			getRecognitionsList()
				.then((response) => state.recognitions = response)
				.catch((error) => console.error(error)),
			getUserLatestSearches()
				.then((response) => state.latestSearches = response.data)
				.catch((error) => console.error(error)),
			getTrends()
				.then((response) => state.trends = response.data)
				.catch((error) => console.error(error)),
		]
		Promise.all(promises).then(() => {
			state.isLoadedPrivate = true;
			if(!!(state.isLoadedPrivate && state.isLoadedPublic)){
				EventBusCase.$emit("isLoaded", true);
			}
		});
	}
};

export default {state, getters, actions, mutations};
